import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SliderBox } from '../../../molecules/slider-box';

export const SettingsBoilerSpotTemp = () => {
  return (
    <SliderBox
      title={
        <FormattedMessage
          id="boiler.settings.temp_spot"
          defaultMessage="Teplota ze spotu pomocí EK"
        />
      }
      subtitle={
        <FormattedMessage
          id="boiler.settings.temp_spot.subtitle"
          defaultMessage="Předehřívací teplota, která je pouze z nízké ceny"
        />
      }
      variableId="HW_SPOT_TEMP_EK"
      visibility={{
        variableIds: ['SP_INSTALL', 'HW_TEMP_ENABLED'],
      }}
      max={85}
      opts={{
        style: 'unit',
        unit: 'celsius',
        maximumFractionDigits: 0,
      }}
    />
  );
};
